export default __webpack_public_path__ + "static/media/email_alert.3a0202bb.svg";